import { ContentLayout } from "@/components/Layout";
import { Authorization, ROLES } from "@/libs/authorization";
import { Header } from "../components/post";
import { ViewArticleScreen } from "../components";
import usePermission from "@/hooks/usePermission";

export const Articles = () => {
  const { showArticle } = usePermission();

  return (
    <ContentLayout title="Articles" header={<Header />}>
      <div className="bg-white flex mb-6 rounded-2xl flex-col dark:bg-slate-900/70">
        <div className="flex-1">
          <Authorization
            forbiddenFallback={<div>Only User can view this.</div>}
            allowedRoles={[ROLES.USER]}
            policyCheck={showArticle}
          >
            <ViewArticleScreen />
          </Authorization>
        </div>
      </div>
    </ContentLayout>
  );
};
